import { render, staticRenderFns } from "./RelatedPosts.vue?vue&type=template&id=5358a15c"
import script from "./RelatedPosts.vue?vue&type=script&lang=js"
export * from "./RelatedPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonLink: require('/srv/app/components/button/Link.vue').default,CardNewsroom: require('/srv/app/components/card/CardNewsroom.vue').default,Button: require('/srv/app/components/button/Button.vue').default})
